export default __webpack_public_path__ + "static/media/1027-00 unfolded.a3f2d1c5.jpg";